// extracted by mini-css-extract-plugin
module.exports = {"shopOwner":"businessHome_shopOwner__29CF-"};